import {
  SET_LOADING_ORGANIZATION,
  GET_ORGANIZATIONS,
  GET_SINGLE_ORGANIZATIONS,
  GET_DEMANDS_ORGANIZATIONS,
  GET_SINGLE_DEMANDS_ORGANIZATIONS,
  GET_ORGANIZATIONS_SEND_REQUEST,
  GET_ORGANIZATIONS_HAS_ROLE,
  GET_ORGANIZATIONS_IS_COURSE_CREATOR,
  GET_ORGANIZATIONS_IS_ADMIN,
  GET_ORGANIZATION_ITEM,
  SET_ORGANIZATION_ITEM,
  UPDATE_DEMAND_ORGANIZATION_ITEM,
  ERROR_ORGANIZATION,
  GET_ORGANIZATION_TEACHERS,
} from '../types';

const initialState = {
  isLoading: false,
  organizations: null,
  singleOrgsDemands: null,
  singleOrganizations: null,
  orgsSendRequest: null,
  orgsHasRole: null,
  orgsIsCourseCreator: null,
  orgsIsAdmin: null,
  orgPeople: null,
  orgRequests: null,
  organizationItem: { data: { name: '', description: '', logo: '' } },
  organizationTeachers: '',
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ORGANIZATIONS:
      return {
        ...state,
        organizations: action.payload,
        isLoading: false,
      };

    case GET_SINGLE_ORGANIZATIONS:
      return {
        ...state,
        singleOrganizations: action.payload,
        isLoading: false,
      };

    case GET_DEMANDS_ORGANIZATIONS:
      return {
        ...state,
        orgsDemands: action.payload,
        isLoading: false,
      };

    case GET_SINGLE_DEMANDS_ORGANIZATIONS:
      return {
        ...state,
        singleOrgsDemands: action.payload,
        isLoading: false,
      };

    case GET_ORGANIZATIONS_SEND_REQUEST:
      return { ...state, orgsSendRequest: action.payload };

    case GET_ORGANIZATIONS_HAS_ROLE:
      return {
        ...state,
        orgsHasRole: action.payload,
        isLoading: false,
      };

    case GET_ORGANIZATIONS_IS_COURSE_CREATOR:
      return {
        ...state,
        orgsIsCourseCreator: action.payload,
        isLoading: false,
      };

    case GET_ORGANIZATIONS_IS_ADMIN:
      return {
        ...state,
        orgsIsAdmin: action.payload,
        isLoading: false,
      };

    case GET_ORGANIZATION_ITEM:
      let { org_data, org_people, org_requests } = action.payload;
      return {
        ...state,
        organizationItem: org_data,
        orgPeople: org_people,
        orgRequests: org_requests,
        isLoading: false,
      };

    case SET_ORGANIZATION_ITEM:
    case UPDATE_DEMAND_ORGANIZATION_ITEM:
      return {
        ...state,
        isLoading: false,
      };

    case SET_LOADING_ORGANIZATION:
      return {
        ...state,
        isLoading: true,
      };

    case ERROR_ORGANIZATION:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case GET_ORGANIZATION_TEACHERS:
      console.log(action.payload, state);
      return {
        ...state,
        organizationTeachers: action.payload,
        isLoading: false,
      };

    default:
      return state;
  }
};
